import { constants } from '../../attributes/CalculatedAlerts';
import FilterTranslatorConverter from '../FilterTranslatorConverter';
import Util from '../../../locatorAlerts/Util';

// creates an object that lists out the filters from the constants object where the key is the constant value and the value is the filter object function
/**
 * Ex.
 * const filterTranslator = {
 *  [constants.THEFT_RECOVERY_ACTIVATED] : () => {
      return {
        type : 'equals',
        field : `data/locatorAlerts@/[constants.THEFT_RECOVERY_ACTIVATED]`,
        value : true
      },
    }, ...etc
 */

const createFilter = constant => () => {
  return {
    type: 'equals',
    field: `data/locator/data/locatorAlerts@/[${constant}]`,
    value: true
  };
};
let filterTranslator = Object.values(constants).reduce((acc, constant) => {
  acc[constant] = createFilter(constant);
  return acc;
}, {});

// add the filters that are not in the locatorAlerts list and are on the vehicle object instead
const specialFilters = {
  [constants.REMOVE_PENDING_SALE]: () => {
    return {
      type: 'logical',
      operator: 'and',
      conditions: [{
        type: 'exists',
        field: 'data/locator/id'
      }, {
        type: 'equals',
        field: 'data/saleState',
        value: constants.REMOVE_PENDING_SALE
      }]
    };
  },
  [constants.REPLACE_PENDING_SALE]: () => {
    return {
      type: 'logical',
      operator: 'and',
      conditions: [{
        type: 'exists',
        field: 'data/locator/id'
      }, {
        type: 'equals',
        field: 'data/saleState',
        value: constants.REPLACE_PENDING_SALE
      }]
    };
  },
  [constants.ADD_PENDING_SALE]: () => {
    return {
      type: 'logical',
      operator: 'or',
      conditions: [{
        type: 'logical',
        operator: 'and',
        conditions: [{
          type: 'exists',
          field: 'data/locator/id',
          not: true
        }, {
          type: 'equals',
          field: 'data/saleState',
          value: constants.REPLACE_PENDING_SALE
        }]
      }, {
        type: 'equals',
        field: 'data/saleState',
        value: constants.ADD_PENDING_SALE
      }]
    };
  },
  [constants.NOT_REPORTING]: () => {
    return Util.notReportingVehicleLocatorsFilter();
  }
};

// merge special cases into filterTranslator
filterTranslator = {
  ...filterTranslator,
  ...specialFilters
};
export default FilterTranslatorConverter.create('vehicle.calculatedAlerts', filterTranslator);